// API Configuration for Serverless Architecture
// This file configures the base URLs for the API Gateway endpoints

// API Gateway URLs from environment configuration (dynamically fetched from AWS)
export const API_CONFIG = {
  // Local development server (for testing)
  LOCAL_API_URL: 'http://localhost:3000',
  
  // Default timeout for API requests
  TIMEOUT: 30000, // 30 seconds
  
  // CORS configuration
  CORS_CONFIG: {
    credentials: 'include' as RequestCredentials,
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    }
  }
};

// Get the appropriate base URL based on environment
export const getBaseApiUrl = (): string => {
  // For local development on localhost, use local server
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return API_CONFIG.LOCAL_API_URL;
  }

  // For deployed environments (dev.axiomteq.com or axiomteq.com),
  // use relative URL so it calls the same domain as the frontend
  // This ensures dev frontend calls dev API, prod frontend calls prod API
  return window.location.origin;
};

// Enhanced API request function with proper error handling and retry logic
export const makeApiRequest = async (
  endpoint: string, 
  options: RequestInit = {}
): Promise<Response> => {
  const baseUrl = getBaseApiUrl();
  const url = endpoint.startsWith('http') ? endpoint : `${baseUrl}/${endpoint}`;
  
  const defaultOptions: RequestInit = {
    ...API_CONFIG.CORS_CONFIG,
    ...options,
    headers: {
      ...API_CONFIG.CORS_CONFIG.headers,
      ...options.headers,
    },
  };

  const response = await fetch(url, defaultOptions);
  return response;
};

// API endpoint constants - Public endpoints only
export const API_ENDPOINTS = {
  // Pages
  PAGES: 'api/pages',
  PAGES_BY_ID: (id: string) => `api/pages/${id}`,
  
  // Content
  INDUSTRIES: 'api/industries',
  PRODUCTS_SERVICES: 'api/products-services',
  COMMUNITY: 'api/community',
  
  // Contact
  CONTACT: 'api/contact',
  
  // Health
  HEALTH: 'api/health'
}; 